import { render, staticRenderFns } from "./ProspectList.vue?vue&type=template&id=4c87770b&"
import script from "./ProspectList.vue?vue&type=script&lang=js&"
export * from "./ProspectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports